<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template #activator="{ on, attrs }">
      <v-list-item v-on="on" v-bind="attrs" @click="openDialog">
        <v-list-item-title>Ver Anexos</v-list-item-title>
      </v-list-item>
    </template>

    <v-card>
      <v-card-title class="green lighten-4 primary--text font-weight-bold">
        {{ titulo }}
      </v-card-title>
      <v-card-subtitle class="green lighten-4">
        {{ afastamento.descsituacao }}
      </v-card-subtitle>

      <v-card-text class="mt-4">
        <v-list>
          <v-list-item
            v-for="anexo in anexos"
            :key="anexo.codigo"
            class="grey lighten-4 mt-1 rounded-lg"
          >
            <v-list-item-content>
              <v-list-item-title>{{ anexo.descricao }}</v-list-item-title>
              <v-list-item-subtitle class="warning--text">
                {{ anexo.obrigatorio ? "Obrigatório" : "" }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                small
                depressed
                color="info"
                @click="visualizarAnexo(anexo.codigo)"
              >
                Visualizar
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn small text @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { getToken } from "@/global";

export default {
  props: {
    afastamento: Object,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapState("atestado", ["anexos", "dados"]),
    titulo() {
      return this.dados === "OUTROS DOCUMENTOS"
        ? "Anexos"
        : "Anexos do afastamento";
    },
  },
  methods: {
    async openDialog() {
      // 1) buscar todos os anexos antes de abrir
      await this.$store.dispatch(
        "atestado/fetchAnexos",
        this.afastamento.codigo,
      );
      // 2) então abre o dialog
      this.dialog = true;
    },
    visualizarAnexo(codigo) {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/colaborador/atestados?funcao=VISUALIZAR-ANEXO` +
          `&token=${getToken()}&id=${codigo}`,
        `${codigo}`,
        `menubar=1,resizable=1,width=${screen.availWidth * 0.45},height=${
          screen.availHeight * 0.95
        }`,
      );
    },
  },
};
</script>
